import { Component, NO_ERRORS_SCHEMA, OnDestroy, OnInit, Input, TemplateRef, Output, EventEmitter, ViewContainerRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule, FormGroup } from '@angular/forms';
import { FaIconLibrary, FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { ButtonsModule } from '@progress/kendo-angular-buttons';
import { DialogCloseResult, DialogService, DialogsModule, WindowModule, DialogContentBase, DialogRef, WindowRef, WindowService, WindowCloseResult } from '@progress/kendo-angular-dialog';
import { GridModule, PagerPosition, PagerType } from '@progress/kendo-angular-grid';
import { InputsModule } from '@progress/kendo-angular-inputs';
import { PagerModule } from '@progress/kendo-angular-pager';
import { MulticheckFilterComponent } from '../filters/multicheck-filter/multicheck-filter.component';
import { ErrorDialogModalComponent } from '../common-components/error-dialog-modal/error-dialog-modal.component';
import { DeleteConfirmComponent } from '../common-components/delete-confirm/delete-confirm.component';
import { BehaviorSubject, Observable, Subscription } from 'rxjs';
import { Release, Project, User } from '../models/models.lib';
import { CompositeFilterDescriptor, distinct, filterBy, orderBy, SortDescriptor } from '@progress/kendo-data-query';
import { CasiCloseOptions, FormModes, AppEnities, defaultGridPageSize } from '../common/constants.lib';
import { ToastrService } from 'ngx-toastr';
import { ReleaseService } from './release.service';
import {
  faPlusCircle, faAddressCard,
  faEdit, faTrash, faEye, faFilePdf
} from '@fortawesome/free-solid-svg-icons';
import { setTitle } from '../common/utils.lib';
//import { EditRoleModalComponent } from './edit-role-modal/edit-role-modal.component';
import { all } from '@awesome.me/kit-787edf9aa0/icons';
import { LoggerService } from '../shared/logger.service';
import { MeService } from '../auth/me.service';
import { ActivatedRoute } from '@angular/router';
import { ReleaseComponent } from './release.component';
import { ViewReleaseComponent } from'./view-release.component';
import { JsReportService } from '../common-services/js-report.service';

//const { ROLE } = AppEnities;

@Component({
  selector: 'release-list',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    FontAwesomeModule,
    InputsModule,
    ButtonsModule,
    DialogsModule,
    WindowModule,
    PagerModule,
    GridModule,
    ErrorDialogModalComponent,
    DeleteConfirmComponent,
    MulticheckFilterComponent
    //EditRoleModalComponent,
  ],
  schemas: [NO_ERRORS_SCHEMA],
  templateUrl: './release-list.component.html',
  styleUrl: './release-list.component.scss'
})
export class ReleaseListComponent implements OnInit, OnDestroy {

  @Input({ required: true }) projectId?: number = undefined;
  @Input({ required: true }) project?: string = undefined;

  @Output() closeForm: EventEmitter<void> = new EventEmitter();
 // public view: Observable<Release[]> = new Observable<Release[]>();
  public rawData: Release[] = [];
  public filter: CompositeFilterDescriptor = { logic: "and", filters: [] };
  public gridData: Release[] = filterBy(this.rawData, this.filter);
  private _windowRef: WindowRef | undefined;
 // public projects: Project[] = [];
 // public users: User[] = [];

  //public permissionSet: Permission[] = []

  public currentRelease: Release = new Release();

  public formMode: FormModes = FormModes.NOTSET;
  public FormModes = FormModes;

  public editWinOpen: boolean = false;
  public errorWinOpen: boolean = false;
  public confirmDeleteRole: boolean = false;
 // public accessRightsWinOpen: boolean = false;
  public errorMsgOpen: boolean = false;
//  public canUpdate: boolean = false;
//  public canCreate: boolean = false;
//  public canDestroy: boolean = false;

  public pagerTypes = ["numeric", "input"];
  public type: PagerType = "numeric";
  public info = true;
  public pageSizes = true;
  public previousNext = true;
  public position: PagerPosition = "bottom";

  public pageSize = defaultGridPageSize;

  private _showTitle = new BehaviorSubject<string>('');
  get showTitle() {
    return this._showTitle.getValue();
  }
  set showTitle(val: string) {
    this._showTitle.next(val);
  }

  private _subs: Subscription[] = [];

  constructor(
    private logger: LoggerService,
    public dataService: ReleaseService,
    public faIcons: FaIconLibrary,
   // private permissionService: PermissionService,
    private toastr: ToastrService,
    private dialogService: DialogService,
    private me: MeService,
    private route: ActivatedRoute,
    private windowService: WindowService,
    private jsReportService: JsReportService,
    private viewContainerRef: ViewContainerRef
   // public override dialog: DialogRef
  ) {
   // super(dialog);
    faIcons.addIcons(
      faPlusCircle, faAddressCard, faEdit,
      faTrash, faEye, faFilePdf
    );
    faIcons.addIcons(...all);
  }

  public sort: SortDescriptor[] = [
    {
      field: "name",
      dir: "asc",
    },
  ];

  ngOnInit(): void {
    this.logger.debug('ngOnInit...');

 //   const { can_Create, can_Update, can_Destroy } = this.me.allICanDo(ROLE)
  //  this.canUpdate = can_Update;
  //  this.canCreate = can_Create;
  //  this.canDestroy = can_Destroy;
    // this.view = this.dataService;

   // this.permissionService.query();
    this._subs.push(this.dataService.subscribe(v => {
      this.logger.debug('ngOnInit:v: ', v);
      this.rawData = v;
      this.loadData();
    }));

    if (this.projectId)
      this.dataService.query(this.projectId);
    // this._subs.push(this.permissionService.subscribe(p => {
    //   this.logger.debug('ngOnInit:p: ', p);
    //   this.permissionSet = p;
    // }))
  }

  ngOnDestroy(): void {
    this.logger.debug('ngOnDestroy...');
    this._subs.forEach(s => s.unsubscribe());
  }

  private loadData(): void {
    this.logger.debug('loadData...');
    this.gridData = orderBy(filterBy(this.rawData, this.filter), this.sort);
    this.pageSize = this.gridData.length;
  }

  public onAddRelease(titleBar: TemplateRef<unknown>): void {
    this.logger.debug("onAddRelease...");
    this.currentRelease = Release.create({project_id: this.projectId})
    this.formMode = FormModes.NEW;
    this.logger.debug("onAddRole:currentRole ", this.currentRelease);
    this.openAddEditDialog(this.formMode, this.currentRelease, titleBar);
  }

  onEditClick(dataItem: any, titleBar: TemplateRef<unknown>): void {
    this.logger.debug("onEditClick: ", dataItem);
    this.currentRelease = Release.create(dataItem);
    this.formMode = FormModes.EDIT;
    this.logger.debug("onEditClick:currentRole ", this.currentRelease);
    this.openAddEditDialog(this.formMode, this.currentRelease, titleBar);
  }

  onViewClick(dataItem: any, titleBar: TemplateRef<unknown>): void {
    this.currentRelease = Release.create(dataItem);
    this.formMode = FormModes.NOTSET;
    this.closeWindowRef();
    this.showTitle = 'VIEW RELEASE';
    this._windowRef = this.windowService.open({
      titleBarContent: titleBar,
      title: this.showTitle,
      content: ViewReleaseComponent,
      width: 1200,
      minWidth: 320,
    });

    const contentRef = this._windowRef.content.instance as ViewReleaseComponent;
  //  contentRef.title = setTitle(mode, 'RELEASE');
    contentRef.release = dataItem;
   // contentRef.mode = mode;
   // contentRef.projectId = this.projectId;

    this._windowRef.result.subscribe(results => {
      this.logger.debug('showAddWindow:results: ', results);
      if (results instanceof WindowCloseResult) {
        this.closeWindowRef();
      }
    });

    this._windowRef.content.instance.closeForm.subscribe((formData: FormGroup) => {
      this.logger.debug('showAddWindow:closeForm: formData: ', formData);
      this.closeWindowRef();
    });

    this.editWinOpen = true;

  }

  onReportClick(dataItem: any): void {
    this.currentRelease = dataItem;
    let reportWindow = window.open("about:blank");
    let title = `${this.currentRelease.project_name} Release Notes (Version ${this.currentRelease.comment})`;
    this.jsReportService.showReportSpinnerPage(reportWindow);
    this.jsReportService.printReleaseReport(this.currentRelease)
      .then(report => {
        const url = URL.createObjectURL(report);
        this.jsReportService.generateReport(reportWindow, title, url);
      })
      .catch(e => {
        this.logger.error("printPDF", e);
        this.jsReportService.showReportErrorPage(reportWindow);
      });
  }

  onConfirmDelete(dataItem: any): void {
    this.logger.debug("onConfirmDelete: ", dataItem);
    this.currentRelease = dataItem;
    this.openConfirmDailog(this.currentRelease);
  }

  //#region Grid function

  public sortChange(sort: SortDescriptor[]): void {
    this.logger.debug("sortChange: ", sort);
    this.sort = sort;
    this.loadData();
  }

  public filterChange(filter: CompositeFilterDescriptor): void {
    // this.logger.debug('filterChange: filter: ', filter);
    this.filter = filter;
    this.loadData();
  }

  public distinctPrimitive(fieldName: string): any[] {
    // this.logger.debug('distinctPrimitive: fieldName: ', fieldName);
    return distinct(this.rawData, fieldName).map((item: any) => item[fieldName]);
    // return distinct(this.gridData, fieldName).map((item: any) => item[fieldName]);
  }

  //#endregion

  public close(args: any): void {
    this.logger.debug('close...', args);
    this.editWinOpen = false;
   // this.handleCloseDeprecated(args);
  }

  // public closeAccessRights(): void {
  //   this.logger.debug('closeAccessRights...');
  //   this.accessRightsWinOpen = false;
  // }

  // public onDialogClose(): void {
  //   this.logger.debug('onDialogClose...');
  //   this.errorWinOpen = false;
  // }

  // public onErrorDialogClose(): void {
  //   this.logger.debug('onErrorDialogClose...');
  //   this.errorMsgOpen = false;
  // }

  // public onRolesPermissionSave(): void {
  //   this.logger.debug('onRolesPermissionSave...');
  //   this.handleAccessRightClose();
  // }

  // //#region Private function

  private openAddEditDialog(mode: FormModes, dataItem: Release, titleBar: TemplateRef<unknown>): void {
    this.logger.debug("openAddEditDialog...");
    this.closeWindowRef();
    this.showTitle = setTitle(mode, 'RELEASE');
    this._windowRef = this.windowService.open({
      titleBarContent: titleBar,
      title: setTitle(mode, 'RELEASE'),
      content: ReleaseComponent,
      width: 1200,
      minWidth: 320,
    });

    const contentRef = this._windowRef.content.instance as ReleaseComponent;
  //  contentRef.title = setTitle(mode, 'RELEASE');
    contentRef.release = dataItem;
    contentRef.mode = mode;
    contentRef.projectId = this.projectId;

    this._windowRef.content.instance.submitForm.subscribe((formData: FormGroup) => {
      this.logger.debug('showAddWindow:formData: ', formData);
      let exists = false;
      for (let i=0; i<this.gridData.length; i++) {
        if (formData.value.comment.trim() == this.gridData[i].comment?.trim() && formData.value.id != this.gridData[i].id) {
          exists = true;
          break;
        }
      }
      if (exists)
        this.openErrorDailog("Duplicate Release", `A release labeled ${formData.value.comment} already exists for this project`, "Close")
      else
        this.saveRelease(formData.value, this.formMode);
    //  this.handleWinRefClose(formData.value, this.formMode);
    });

    this._windowRef.result.subscribe(results => {
      this.logger.debug('showAddWindow:results: ', results);
      if (results instanceof WindowCloseResult) {
        this.closeWindowRef();
      }
    });

    this._windowRef.content.instance.closeForm.subscribe((formData: FormGroup) => {
      this.logger.debug('showAddWindow:closeForm: formData: ', formData);
      this.closeWindowRef();
    });

    this.editWinOpen = true;
  }

  private openErrorDailog(title: string = 'Not set', content: string = 'No content', buttonText: string = 'Close', buttonText2: string = ''): void {
    const dialogRef = this.dialogService.open({
      content: ErrorDialogModalComponent,
      minWidth: 320,
      width: 750,
      cssClass: "custom-css-class",
      appendTo: this.viewContainerRef,
    });

    const contentRef = dialogRef.content.instance as ErrorDialogModalComponent;
    contentRef.title = title;
    contentRef.content = content;
    contentRef.buttonText = buttonText;
    contentRef.buttonText2 = buttonText2;

    dialogRef.result.subscribe((r: any) => {
      this.logger.debug('openDialogForm:result:', r);
      if (r instanceof DialogCloseResult) {
        return;
      }
      // if (r.text === CasiCloseOptions.Ok) {
      //   this.logger.debug("openConfirmDailog:ok to proceed... ", this.currentRole);
      //   this.handleRemove(this.currentRole);
      // }
    });

  }

  private closeWindowRef() {
    this.editWinOpen = false;
    this._windowRef?.close();
    this._windowRef = undefined;
  }

  private saveRelease(release: any, mode: FormModes): void {
    this.logger.debug('saveRole...', release, mode);
    if (mode === FormModes.EDIT) {
      this.dataService.update(release)
        .then(resp => {
          this.logger.debug('saveRelease:update:resp: ', resp);
          this.notify("Release Updated");
          this.dataService.query(this.projectId!);
          this.closeWindowRef();
        })
        .catch(err => {
          this.logger.error('saveRelease:update:err: ', err);
          this.notify("Error Updating Release", true);
        });
    } else {
      this.dataService.addAssign(release)
        .then(resp => {
          this.logger.debug('saveRelease:add:resp: ', resp);
          this.notify("Release Added");
          this.dataService.query(this.projectId!);
          this.closeWindowRef();
        })
        .catch(err => {
          this.logger.error('saveRelease:add:err: ', err);
          this.notify("Error Creating Release", true);
        });
    }
  }

  private notify(msg: string, error: boolean = false): void {
    this.logger.debug("notify", msg);
    if (error)
      this.toastr.error(msg);
    else
      this.toastr.success(msg);
  }

  private openConfirmDailog(dataItem: any): void {
    this.logger.debug("openConfirmDailog: ", dataItem);
    // this.currentRole = dataItem;
    const dialogRef = this.dialogService.open({
      content: DeleteConfirmComponent,
      minWidth: 250,
      width: 450,
      // cssClass: "custom-css-class"
    });

    const contentRef = dialogRef.content.instance as DeleteConfirmComponent;
    contentRef.title = "CONFIRM DELETE";
    contentRef.content = `Delete Release - <b>${this.currentRelease.comment}</b>?`;

    dialogRef.result.subscribe((r: any) => {
      this.logger.debug('openDialogForm:result:', r);
      if (r instanceof DialogCloseResult) {
        return;
      }
      if (r.text === CasiCloseOptions.Ok) {
        this.logger.debug("openConfirmDailog:ok to proceed... ", this.currentRelease);
        this.handleRemove(this.currentRelease);
      }
    });
  }

  private handleRemove(args: any): void {
    if (args && args.id) {
     // this.logger.error('handlRemove: No id given');
     this.dataService.destroy(args.id)
      .then(resp => {
        this.logger.debug('handleRemove:resp: ', resp);
        this.notify("Release Deleted");
        this.dataService.query(this.projectId!);
      })
      .catch(err => {
        this.logger.error('handleRemove:err: ', err);
        this.notify("Error Deleting Release", true);

      });
    }
  }

  public onClose(): void {
    this.logger.debug(`onCancelAction...`);
    this.closeForm.emit();
   // this.dialog.close({ text: CasiCloseOptions.Cancelled });
  }



}
